import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'welcome-to-prefund',
  standalone: true,
  imports: [],
  templateUrl: './welcome-to-prefund.component.html',
  styleUrl: './welcome-to-prefund.component.scss',
})
export class WelcomeToPrefundComponent {
  @Output() addEntry = new EventEmitter();
  @Output() openPlanner = new EventEmitter();
}
